
/* This Section for Route Page */
const pathList = {
    login             : {name : "login", path : "/" },
    registration      : {name : "registration", path : "/registration/:type" },
    feed              : {name  : "feed",  path : "/feed" },
    user              : {name  : "user",  path : "/user/:id" },
    usertab           : {name  : "user",  path : "/user/:id/:tabid" },
    post              : {name  : "post",  path : "/post/:id" },
    media             : {name  : "media",  path : "/media/:id" },
    album             : {name  : "album",  path : "/album/:id" },
    album_edit        : {name  : "album_edit",  path : "/album_edit/:id" },
    promotion         : {name  : "promotion",  path : "/promotion/:id" },
    promotion_create  : {name  : "promotion_create",  path : "/promotion_create" },
    promotion_preview : {name  : "promotion_preview",  path : "/promotion_preview" },
    promotion_edit    : {name  : "promotion_edit",  path : "/promotion_edit" },
    promotion_list    : {name  : "promotion_list",  path : "/promotion_list" },
    promotion_detail  : {name  : "promotion_detail",  path : "/promotion_detail/:id" },
    chat              : {name  : "chat",  path : "/chat/:id" },
    search            : {name  : "search",  path : "/search" },
    polling           : {name  : "polling",  path : "/polling/:id" },
    
};

/* 
export const sideMenuItems = [
  {
    name : languagelist.menu_promotion,
    icon : my_golden_space_icon,
    path : "/promotion_list"
  },
  {
    name : languagelist.menu_profile,
    icon : profile_icon,
    path : ""
  },
  {
    name : languagelist.menu_gallery,
    icon : gallery_icon,
    path : ""
  },
  {
    name : languagelist.menu_events,
    icon : events_icon,
    path : ""
  },
  {
    name : languagelist.menu_friends,
    icon : my_friends_icon,
    path : ""
  },
  {
    name : languagelist.menu_page,
    icon : page_icon,
    path : ""
  },
  {
    name : languagelist.menu_terms,
    icon : tos_icon,
    path : ""
  },
  {
    name : languagelist.menu_privacy,
    icon : pp_icon,
    path : ""
  },
  {
    name : languagelist.menu_faq,
    icon : faq_icon,
    path : ""
  },

  {
    name : languagelist.logout,
    icon : logout_icon,
    path : pathList.login.path
  }
]; */

export default pathList;